import {appendPaginationQueryParamsToUrl, get} from "../utils";

export default host => (options) =>
  get(appendPaginationQueryParamsToUrl(`${host}/clients/catalogs/downloadLink?order_by=name`,
    {...options, alreadyHasQueryParams: true}))
  .then(response => response.text())